import { createFileRoute } from '@tanstack/react-router';
import { CampaignsLayout } from '@web/modules/campaigns/layout/campaigns-layout';

/**
 * The campaigns area (spec 022): the areas as tabs on top, each screen under them.
 * `?compose=new|<id>` opens the broadcast assistant over any of them; `?modal=journey|event|
 * audience[:<id>]` the other work windows.
 */
export const Route = createFileRoute('/_app/campaigns')({
  validateSearch: (search: Record<string, unknown>): { compose?: string; modal?: string } => ({
    ...(typeof search['compose'] === 'string' && search['compose'] !== ''
      ? { compose: search['compose'] }
      : {}),
    ...(typeof search['modal'] === 'string' && search['modal'] !== ''
      ? { modal: search['modal'] }
      : {}),
  }),
  component: CampaignsLayout,
});
